import { render, staticRenderFns } from "./UpdatePersonalInfoAddress.vue?vue&type=template&id=463b8184"
import script from "./UpdatePersonalInfoAddress.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalInfoAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports